import { render, staticRenderFns } from "./ResourceCredentialsFormRow.vue?vue&type=template&id=396a0b4c&scoped=true"
import script from "./ResourceCredentialsFormRow.vue?vue&type=script&lang=js"
export * from "./ResourceCredentialsFormRow.vue?vue&type=script&lang=js"
import style0 from "./ResourceCredentialsFormRow.vue?vue&type=style&index=0&id=396a0b4c&prod&lang=scss"
import style1 from "./ResourceCredentialsFormRow.vue?vue&type=style&index=1&id=396a0b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a0b4c",
  null
  
)

export default component.exports